import { twMerge } from 'tailwind-merge';
import { useEffect, useState } from 'react';
import UpInput from '../../../components/UpInput';

interface SaveAsSelectProps {
  onSelect?: (tag: string) => void;
  defaultSelected?: string | undefined;
}

const SaveAsSelect: React.FC<SaveAsSelectProps> = ({
  onSelect,
  defaultSelected,
}) => {
  const categories = ['Home', 'Work', 'Family & Friends', 'Other'];
  const [selected, setSelected] = useState<string>(
    defaultSelected && categories?.includes(defaultSelected)
      ? defaultSelected
      : 'Other',
  );
  const [tagText, setTagText] = useState<string>('');

  useEffect(() => {
    if (onSelect) {
      onSelect(selected === 'Other' ? tagText : selected);
    }
  }, [onSelect, selected, tagText]);

  return (
    <div className="w-full max-w-lg">
      <label className="block text-sm mb-1.5">Save As</label>
      <div className="flex gap-3 overflow-x-auto pb-2 mb-1">
        {categories.map((category: string) => (
          <button
            type="button"
            key={category}
            onClick={() => {
              setSelected(category);
            }}
            className={twMerge(
              'px-4 py-2 rounded-xl text-sm transition-all bg-white border-1 min-w-max',
              selected === category
                ? 'text-brand-highlight border-brand-highlight'
                : 'border-dashed border-up-black-20',
            )}>
            {category}
          </button>
        ))}
      </div>
      {selected === 'Other' && (
        <UpInput
          value={tagText}
          onChange={e => {
            setTagText(e.target.value);
          }}
          placeholder="Enter address tag"
        />
      )}
    </div>
  );
};

export default SaveAsSelect;
